import { EmailLength, EmailRelationship, EmailTone } from "../services/emailGenerator.service";

export const CONTACT_NAME_MAX_LENGTH = 25;

export const toneOptions: EmailTone[] = ["Formal", "Neutral", "Informal"];

export const lengthOptions: EmailLength[] = ["Short", "Medium", "In-Depth"];

export const relationshipOptions: { value: EmailRelationship; label: string }[] = [
  { value: "cold", label: "Cold (new potential customer)" },
  { value: "warm", label: "Warm (new customer)" },
  { value: "hot", label: "Hot (existing customer)" },
];
